import "../src/global/global-mobile"

import "@modules/solads/solads"
import "@modules/webcams/mobile.css"
import "@modules/single-page/mobile.css"
import "@modules/banner/donnerstag/header-donnerstag-mobile.css"
import "@modules/banner/donnerstag/footer-donnerstag-mobile.css"
import "@modules/webcams/webcamsVideoLogic.ts"
import { setAZMFilterPath } from "@modules/global/filter-path/filter-path-handler.ts"

setAZMFilterPath()
